import { protectedApi } from '@api/index';
import { formatApiResponse } from '@utils/helpers';

export async function getStateListApi() {
    const endpoint = `/state/list`;
    try {
      const response = await protectedApi.get(endpoint);
      return formatApiResponse(response);
    } catch (error) {
      return formatApiResponse(error);
    }
  }